import FloatingLabelInput from './FloatingLabelInput';

const FloatingLabelInputGroup = ({ 
  inputs, // Array of inputs [{ label, value, onChange, error, disabled }]
  stacked = false, // Force stacked layout if true
}) => {
  return (
    <div 
      className={`input-group ${stacked ? 'stacked' : ''}`}
    >
      {inputs.map((inputProps, index) => (
        <FloatingLabelInput key={index} {...inputProps} />
      ))}
    </div>
  );
};

export default FloatingLabelInputGroup;